import { PropsWithChildren } from "react";

import SplashScreen from "@/components/SplashScreen";
import { useDomainBrandingContext } from "@/contexts";

export const AuthSplashScreenProvider = ({ children }: PropsWithChildren) => {
  const { loading } = useDomainBrandingContext();

  if (loading) {
    return <SplashScreen className="bg-surface-1" />;
  }

  return <>{children}</>;
};
